import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ApplicationsComponent } from './components/applications.component';
import { SiteTrafficComponent } from './components/site-traffic.component';

@NgModule({
  declarations: [ApplicationsComponent, SiteTrafficComponent],
  imports: [
      CommonModule,
      SharedModule
  ]
})
export class ReportingModule { }
